"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INoteFrozen = exports.INoteInactive = exports.INoteType = void 0;
var INoteType;
(function (INoteType) {
    INoteType["NOTE_NOTE"] = "note";
    INoteType["RELEASE_RELEASE"] = "release";
    INoteType["REVIEW_REVIEW"] = "review";
    INoteType["REREVIEW_REREVIEW"] = "reReview";
    INoteType["AMEX_SALES_AMEXSALES"] = "amexSales";
    INoteType["BUSINESS_SALES_BUSINESSSALES"] = "businessSales";
    INoteType["CONSUMER_SALES_CONSUMERSALES"] = "consumerSales";
    INoteType["DELIVERY_SCHEDULE_DELIVERYSCHEDULE"] = "deliverySchedule";
    INoteType["IMMEDIATE_DELIVERY_PERCENT_IMMEDIATEDELIVERYPERCENT"] = "immediateDeliveryPercent";
    INoteType["SEVEN_DAY_DELIVERY_PERCENT_SEVENDAYDELIVERYPERCENT"] = "sevenDayDeliveryPercent";
    INoteType["FOURTEEN_DAY_DELIVERY_PERCENT_FOURTEENDAYDELIVERYPERCENT"] = "fourteenDayDeliveryPercent";
    INoteType["THIRTY_DAY_DELIVERY_PERCENT_THIRTYDAYDELIVERYPERCENT"] = "thirtyDayDeliveryPercent";
    INoteType["CARD_PRESENT_SALES_CARDPRESENTSALES"] = "cardPresentSales";
    INoteType["MOTO_SALES_MOTOSALES"] = "motoSales";
    INoteType["ECOMMERCE_SALES_ECOMMERCESALES"] = "ecommerceSales";
    INoteType["SITE_VISIT_SITEVISIT"] = "siteVisit";
    INoteType["GOODS_SOLD_GOODSSOLD"] = "goodsSold";
    INoteType["AUTHORIZATION_FLAT_FEE_AUTHORIZATIONFLATFEE"] = "authorizationFlatFee";
    INoteType["CAPTURE_PERCENT_FEE_CAPTUREPERCENTFEE"] = "capturePercentFee";
    INoteType["CAPTURE_FLAT_FEE_CAPTUREFLATFEE"] = "captureFlatFee";
    INoteType["RISK_APPROVED_RISKAPPROVED"] = "riskApproved";
    INoteType["RISK_PENDING_RISKPENDING"] = "riskPending";
    INoteType["RISK_CANCELLED_RISKCANCELLED"] = "riskCancelled";
    INoteType["RISK_DENIED_RISKDENIED"] = "riskDenied";
    INoteType["RISK_DENIED_RISKCLOSED"] = "riskClosed";
    INoteType["RISK_INVESTIGAGION_RISKINVESTIGATION"] = "riskInvestigation";
    INoteType["RISK_PENDING_DATA_RISKPENDINGDATA"] = "riskPendingData";
    INoteType["RISK_FUNDS_RELEASED_RISKFUNDSRELEASED"] = "riskFundsReleased";
    INoteType["RISK_ACTIVITY_APPROVED_RISKACTIVITYAPPROVED"] = "riskActivityApproved";
})(INoteType = exports.INoteType || (exports.INoteType = {}));
var INoteInactive;
(function (INoteInactive) {
    INoteInactive[INoteInactive["ACTIVE_0"] = 0] = "ACTIVE_0";
    INoteInactive[INoteInactive["INACTIVE_1"] = 1] = "INACTIVE_1";
})(INoteInactive = exports.INoteInactive || (exports.INoteInactive = {}));
var INoteFrozen;
(function (INoteFrozen) {
    INoteFrozen[INoteFrozen["NOT_FROZEN_0"] = 0] = "NOT_FROZEN_0";
    INoteFrozen[INoteFrozen["FROZEN_1"] = 1] = "FROZEN_1";
})(INoteFrozen = exports.INoteFrozen || (exports.INoteFrozen = {}));
